import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class CustomTranslateHttpLoader implements TranslateLoader {
  private prefix: string;
  private suffix: string;

  constructor(
    private http: HttpClient,
    prefix: string = '/assets/i18n/',
    suffix: string = '.json',
  ) {
    // Get the base href from the document
    const baseElement = document.getElementsByTagName('base')[0];
    const baseHref = baseElement
      ? baseElement.getAttribute('href') || '/'
      : '/';

    // Handle different base href scenarios
    if (baseHref === '/') {
      // Root deployment - use prefix as-is
      this.prefix = prefix;
    } else {
      // Subpath deployment - ensure prefix includes the base path
      const cleanBaseHref = baseHref.replace(/\/$/, ''); // Remove trailing slash

      // Always prepend the base path for subpath deployments
      this.prefix = cleanBaseHref + prefix;
    }

    this.suffix = suffix;
  }

  getTranslation(lang: string): Observable<any> {
    const translationUrl = `${this.prefix}${lang}${this.suffix}`;
    return this.http.get(translationUrl);
  }
}

export function customTranslateLoader(http: HttpClient) {
  return new CustomTranslateHttpLoader(http);
}
